import React from "react";
export var RequiredIndicator = function () { return (React.createElement("span", { style: { color: "red", paddingLeft: "3px" } }, "*")); };
